module.exports = __webpack_public_path__ + "static/media/generic_picture.c9dc14a8.svg";